import {
  createStore
} from 'vuex'
import persistedState from 'vuex-persistedstate'
export default createStore({
  state: {
    token: '', //储存token
    dealerCode: '',
    dealerId: '',
    // isLoggedIn: false,
    // role: '',
    // pageState: {},
    // pageStateD: {},
  },
  getters: {
    getMenuData: (state) => state.menuData,
    getRootSubmenuKeys: (state) => state.rootSubmenuKeys,
    getExportPermissions: (state) => state.exportPermissions,

  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setDealerUserInfo(state, dealerUserInfo) {
      state.dealerCode = dealerUserInfo
    },
    setDealerId(state, dealerId) {
      state.dealerId = dealerId
    },
    // setRole(state, role) {
    //   state.role = role
    // },
    // setPageState(state, pageState) {
    //   state.pageState = pageState
    // },
    // setPageStateD(state, pageStateD) {
    //   state.pageStateD = pageStateD
    // },
    // setLoggedIn(state, isLoggedIn) {
    //   state.isLoggedIn = isLoggedIn;
    //   console.log(state.isLoggedIn, 'state.isLoggedIn');
    // },
  },
  actions: {},
  modules: {},
  plugins: [persistedState({
    paths: ['token', 'dealerCode', 'dealerId', ],
  })]
})